// extracted by mini-css-extract-plugin
export default {"melodyVideo":"vJ-z","isFullWidth":"wJ-z","landingPageVideo":"xJ-z","play":"yJ-z","iframeVideo":"zJ-z","playHidden":"AJ-z","fullwidth":"BJ-z"};